import React from 'react'

import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardText from "components/Card/CardText";
import { CardFooter } from 'reactstrap';

function CardSection({ classes, headerColor = 'danger', title, titleImage, legends = [], cardBody, cardFooter, children }) {
  return (
    <Card style={{ maxHeight: '100%' }} >
      <CardHeader color={headerColor} stats text>
        <div className={classes.rowDirection}>
          <CardText color={headerColor}>
            <div className={classes.titleLogoContainer}>
              <img src={titleImage} alt='titlelogo' className={classes.titleLogo} />
              <h3 className={classes.cardTitle}>{title}</h3>
            </div>
          </CardText>
          <div className={classes.legendBox}>
            {
              legends.map((legend, idx) => <div key={idx} className='d-inline-flex justify-content-center align-items-center'>
                <div className={classes[legend.className]} />{legend.title}
              </div>)
            }
          </div>
        </div>
      </CardHeader>

      {
        cardBody
          ? <CardBody className='d-flex justify-content-center align-items-center'>
            {cardBody}
          </CardBody>
          : <CardBody className='d-flex justify-content-center align-items-center'>
            {children}
          </CardBody>
      }
      {
        cardFooter
          ? <CardFooter>
            {cardFooter}
          </CardFooter>
          : null
      }
    </Card>
  )
}




export default CardSection
